"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundamentalistImpression = void 0;
const lodash_1 = require("lodash");
const lucy_1 = require("../../@types/analysis/historical-prices/lucy");
const cashflow_impressions_data_1 = require("./data/fundamentalist/cashflow-impressions.data");
const patrimony_balance_impressions_data_1 = require("./data/fundamentalist/patrimony-balance-impressions.data");
const demonstrations_impressions_1 = require("./data/fundamentalist/demonstrations.impressions");
const fundamental_utils_1 = require("../utils/fundamental.utils");
class FundamentalistImpression {
    getAll(fundamentalData) {
        const { CashFlow: cashFlow, PatrimonyBalance: patrimonyBalance, ResultsDemonstration: demonstrations, } = fundamentalData;
        let impressions = [];
        if (!(0, lodash_1.isEmpty)(cashFlow)) {
            impressions = [...this.getCashFlowImpressions(cashFlow)];
        }
        if (!(0, lodash_1.isEmpty)(patrimonyBalance)) {
            impressions = [...this.getPatrimonyBalanceImpressions(patrimonyBalance)];
        }
        if (!(0, lodash_1.isEmpty)(demonstrations)) {
            impressions = [
                ...impressions,
                ...this.getDemonstrationImpressions(demonstrations),
            ];
        }
        return impressions;
    }
    getCashFlowImpressions(cashFlow) {
        const { OperationalActivity: operational, InvestimentsActivity: investments, LiquidVariations: liquid, } = cashFlow;
        const impressions = [];
        const operationalIndication = fundamental_utils_1.FundamentalUtils.getLucyIndication(operational);
        const investmentsIndication = fundamental_utils_1.FundamentalUtils.getLucyIndication(investments);
        const liquidIndication = fundamental_utils_1.FundamentalUtils.getLucyIndication(liquid);
        switch (operationalIndication) {
            case lucy_1.eLucyFundamentalIndication.STRONG_BUY:
                impressions.push(this.getCashflowImpressionById(0));
                break;
            case lucy_1.eLucyFundamentalIndication.STRONG_SELL:
                impressions.push(this.getCashflowImpressionById(5));
                break;
        }
        if (investmentsIndication === lucy_1.eLucyFundamentalIndication.STRONG_BUY) {
            impressions.push(this.getCashflowImpressionById(1));
        }
        switch (liquidIndication) {
            case lucy_1.eLucyFundamentalIndication.STRONG_BUY:
                impressions.push(this.getCashflowImpressionById(2));
                break;
            case lucy_1.eLucyFundamentalIndication.STRONG_SELL:
                impressions.push(this.getCashflowImpressionById(3));
                break;
            case lucy_1.eLucyFundamentalIndication.SELL:
                impressions.push(this.getCashflowImpressionById(4));
                break;
        }
        return impressions;
    }
    getPatrimonyBalanceImpressions(patrimonyBalance) {
        const impressions = [];
        const totalPatrimonyLiquid = patrimonyBalance.TotalLiquid;
        if (totalPatrimonyLiquid) {
            const indication = fundamental_utils_1.FundamentalUtils.getLucyIndication(totalPatrimonyLiquid);
            switch (indication) {
                case lucy_1.eLucyFundamentalIndication.STRONG_BUY:
                    impressions.push(this.getPatrimonyImpressionById(0));
                    break;
                case lucy_1.eLucyFundamentalIndication.BUY:
                    impressions.push(this.getPatrimonyImpressionById(1));
                    break;
                case lucy_1.eLucyFundamentalIndication.SELL:
                    impressions.push(this.getPatrimonyImpressionById(2));
                    break;
            }
        }
        return impressions;
    }
    getDemonstrationImpressions(demonstrations) {
        const impressions = [];
        const { TotalReceipt: totalReceipt, ClearProfit: clearProfit } = demonstrations;
        if (!(0, lodash_1.isEmpty)(totalReceipt)) {
            const indication = fundamental_utils_1.FundamentalUtils.getLucyIndication(totalReceipt);
            switch (indication) {
                case lucy_1.eLucyFundamentalIndication.STRONG_BUY:
                    impressions.push(this.getDemonstrationImpressionById(0));
                    break;
                case lucy_1.eLucyFundamentalIndication.STRONG_SELL:
                    impressions.push(this.getDemonstrationImpressionById(1));
                    break;
                case lucy_1.eLucyFundamentalIndication.SELL:
                    impressions.push(this.getDemonstrationImpressionById(2));
                    break;
            }
        }
        return impressions;
    }
    getCashflowImpressionById(id) {
        return cashflow_impressions_data_1.cashflowImpressionsList.find((item) => item.id === id);
    }
    getPatrimonyImpressionById(id) {
        return patrimony_balance_impressions_data_1.patrimonyBalanceImpressionsList.find((item) => item.id === id);
    }
    getDemonstrationImpressionById(id) {
        return demonstrations_impressions_1.demonstrationsImpressionsList.find((item) => item.id === id);
    }
}
exports.FundamentalistImpression = FundamentalistImpression;
//# sourceMappingURL=fundamentalist.impression.js.map